import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { Tag } from "../../models";
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { cloneDeep, isEqual } from "lodash-es";
import { CommonModule } from "@angular/common";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgScrollbarModule } from "ngx-scrollbar";
import { TPipe } from '../i18n/t.pipe';

@Component({
    selector: 'tag-editor',
    templateUrl: 'tag-editor.component.html',
    styleUrls: ['tag-editor.component.scss'],
    imports: [TPipe, CommonModule, ReactiveFormsModule, NgbDropdownModule]
})
  export class TagEditorComponent {

    @Input() tags: Tag[];
    @Input() selected: Tag[];
    @Input() debug: boolean = false;
    @Input() color: string = "#5d78ff";
    @Output() public Save: EventEmitter<any> = new EventEmitter(); 
    checkboxGroup: FormGroup;
    initial_selection: Tag[];


    constructor(
        private fb: FormBuilder,
		private cd: ChangeDetectorRef
    ){

        this.checkboxGroup = this.fb.group({
            myValues: new FormArray([])
          });

    
    }

    ngOnChanges(changes: SimpleChanges): void {
        // load initially selected tags

        if( changes['selected'] ) {

            var selected_tags = (changes['selected'].currentValue as Array<Tag>);

            if (selected_tags){

                // reset form first, otherwise controls will be added twice on contact details save
                var myValues = (this.checkboxGroup.controls['myValues'] as FormArray);
                myValues.clear();

                // update the form
                selected_tags.forEach( (tag) => {
                    this.update_form(true, tag.id)
                });    
            }
        }
    }


    is_selected(tag_id: number){
        return this.selected?.find(t => t.id == tag_id);
    }

    openChange(isOpened){
        if (!isOpened) {
            if ( !(isEqual(this.selected, this.initial_selection))) {
                this.Save.emit( this.selected );
            }
        } else {
            // store initial selection, needed later to revert to it if user
            // didnt select something
            this.initial_selection  = cloneDeep(this.selected);
        }
    }

    onCheckboxChange(event: any) {
            
        this.update_form(event.target.checked, parseInt(event.target.value) );

        this.update_selected();

    }

    update_form(is_checked: boolean, value: number){

        const myValues = (this.checkboxGroup.controls['myValues'] as FormArray);

        if (is_checked) {
            myValues.push(new FormControl(value));

          } else {
            const index = myValues.controls
            .findIndex(x => x.value === value);
            myValues.removeAt(index);
  
          }

    }

    update_selected(){

        const myValues = (this.checkboxGroup.controls['myValues'] as FormArray);

        this.selected = [];
        for (let control of myValues.controls) {
            const t = this.tags.find(t => t.id == parseInt(control.value));
            this.selected.push(t);
        }
    }


  }
    